export enum VehicleColor {
    White,
    Black,
    Gray,
    Silver,
    Red,
    Green,
    Blue,
    Brown,
    Orange,
    Purple,
    Gold,
    Yellow,
    Unsure
}

export function showVehicleColor( color: VehicleColor ): string {
    switch( color ) {
        case VehicleColor.White:  return "White";
        case VehicleColor.Black:  return "Black";
        case VehicleColor.Gray:   return "Gray";
        case VehicleColor.Silver: return "Silver";
        case VehicleColor.Red:    return "Red";
        case VehicleColor.Green:  return "Green";
        case VehicleColor.Blue:   return "Blue";
        case VehicleColor.Brown:  return "Brown";
        case VehicleColor.Orange: return "Orange";
        case VehicleColor.Purple: return "Purple";
        case VehicleColor.Gold:   return "Gold";
        case VehicleColor.Yellow: return "Yellow";
        case VehicleColor.Unsure: return "Unsure";
    }
}

export function parseVehicleColor( str: string ): VehicleColor | undefined {
    switch( str ) {
        case "White":  return VehicleColor.White;
        case "Black":  return VehicleColor.Black;
        case "Gray":   return VehicleColor.Gray;
        case "Silver": return VehicleColor.Silver;
        case "Red":    return VehicleColor.Red;
        case "Green":  return VehicleColor.Green;
        case "Blue":   return VehicleColor.Blue;
        case "Brown":  return VehicleColor.Brown;
        case "Orange": return VehicleColor.Orange;
        case "Purple": return VehicleColor.Purple;
        case "Gold":   return VehicleColor.Gold;
        case "Yellow": return VehicleColor.Yellow;
        case "Unsure": return VehicleColor.Unsure;
        default:       return undefined;
    }
}

export const vehicleColors: VehicleColor[] = [
    VehicleColor.White,
    VehicleColor.Black,
    VehicleColor.Gray,
    VehicleColor.Silver,
    VehicleColor.Red,
    VehicleColor.Green,
    VehicleColor.Blue,
    VehicleColor.Brown,
    VehicleColor.Orange,
    VehicleColor.Purple,
    VehicleColor.Gold,
    VehicleColor.Yellow,
    VehicleColor.Unsure
];